const variables = !!process.env.REACT_APP_ENV  ?  require('../config/_processEnv').default : require('../config/_localVars').default

export default variables